import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

const BrandingContext = createContext({
  logo: "",
  favicon: "",
  font: "Barlow Condensed",
  availableFonts: [],
  reload: () => {},
});

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({ logo: "", favicon: "", font: "Barlow Condensed", availableFonts: [] });

  const load = useCallback(() => {
    api.getBranding()
      .then((res) => {
        setBranding({
          logo: res.data.logo || "",
          favicon: res.data.favicon || "",
          font: res.data.font || "Barlow Condensed",
          availableFonts: res.data.available_fonts || [],
        });
      })
      .catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);

  // Apply font globally
  useEffect(() => {
    if (!branding.font) return;
    const fontName = branding.font.replace(/ /g, "+");
    const linkId = "google-font-link";
    let link = document.getElementById(linkId);
    if (!link) {
      link = document.createElement("link");
      link.id = linkId;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    link.href = `https://fonts.googleapis.com/css2?family=${fontName}:wght@300;400;500;600;700&display=swap`;
    document.documentElement.style.setProperty("--brand-font", `'${branding.font}', system-ui, sans-serif`);
  }, [branding.font]);

  // Apply favicon
  useEffect(() => {
    if (!branding.favicon) return;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = branding.favicon;
  }, [branding.favicon]);

  return (
    <BrandingContext.Provider value={{ ...branding, reload: load }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
